<template>
  <div>
    <SettingsMobile />
  </div>
</template>

<script>
import SettingsMobile from "../../components/Settings/Index-SettingsMobile.vue";
export default {
  components: {
    SettingsMobile,
  },
};
</script>